import React, { useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import axios from "axios";

const BulkImageUploadForm = () => {
  const [images, setImages] = useState([]);
  const [response, setResponse] = useState(null);
  const [errors, setErrors] = useState([]);

  const handleFileChange = (e) => {
    setImages(Array.from(e.target.files));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (images.length === 0) {
      alert("Please select images before submitting.");
      return;
    }

    const formData = new FormData();
    images.forEach((image) => formData.append("images", image));

    try {
      const res = await axios.put("/api/products/bulk-upload/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setResponse(res.data.updated);
      setErrors(res.data.errors);
    } catch (err) {
      console.error("Upload failed", err);
      alert("Something went wrong during upload.");
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="formFileMultiple" className="mb-3">
        <Form.Label>Upload Product Images</Form.Label>
        <Form.Control type="file" multiple onChange={handleFileChange} />
      </Form.Group>
      <Button variant="primary" type="submit">
        Submit
      </Button>

      {response && (
        <Alert variant="success" className="mt-3">
          Updated Products: {response.join(", ")}
        </Alert>
      )}
      {errors.length > 0 && (
        <Alert variant="danger" className="mt-3">
          <ul>
            {errors.map((err, i) => (
              <li key={i}>
                Tag {err.tag_no}: {err.error}
              </li>
            ))}
          </ul>
        </Alert>
      )}
    </Form>
  );
};

export default BulkImageUploadForm;
